import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { FeatureFlag, FeatureFlagService } from 'common';
import { routerTransition } from '../../../shared/animations/router.animations';
import { readWrite } from '../../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../../user/user-permission/user-permission.service';

@UntilDestroy()
@Component({
    selector: 'ifb-feature-flag-list',
    templateUrl: './feature-flag-list.component.html',
    styleUrls: ['./feature-flag-list.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class FeatureFlagListComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  tableColumns = [
    { def: 'code', mainList: true },
    { def: 'description', mainList: true },
    { def: 'createdOn', mainList: true },
    { def: 'override', mainList: false },
    { def: 'value', mainList: true }
  ];

  tenantId: any;
  data: FeatureFlagListComponentData;
  readWriteFeatureFlag: boolean;
  dataSource = new MatTableDataSource<FeatureFlag>();
  updatedFeatures: FeatureFlag[] = [];

  constructor (
    private readonly route: ActivatedRoute,
    private readonly userPermissionService: UserPermissionService,
    private readonly service: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe((it: FeatureFlagListComponentData) => {
        this.data = it;
        if (this.data)
          this.dataSource = new MatTableDataSource(this.data.featureFlagListResult);
      });

    this.route.params.pipe(untilDestroyed(this))
      .subscribe((params: any) => { this.tenantId = params.id });

    this.userPermissionService.granted([readWrite('admin-feature-flags')])
      .subscribe(res => this.readWriteFeatureFlag = res);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  update(event, id): void {
    this.service.update(id, event.checked)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => this.service.list()
          .pipe(untilDestroyed(this))
          .subscribe(res => this.dataSource = new MatTableDataSource(res))
      })
  }

  updateForTenant(featureFlag: FeatureFlag, event?): void {
    const index = this.updatedFeatures.findIndex(_ => _.id === featureFlag.id);
    featureFlag.valueForTenant = event ? event.checked : (featureFlag?.valueForTenant ?? featureFlag.value);
    if (index >= 0) {
      this.updatedFeatures[index].override = featureFlag.override;
      this.updatedFeatures[index].valueForTenant = featureFlag.valueForTenant;
    } else {
      this.updatedFeatures.push(featureFlag);
    }
  }

  getDisplayedColumns(): string[] {
    return this.tableColumns
      .filter(cd => !this.tenantId ? cd.mainList : true)
      .map(cd => cd.def);
  }
}

export interface FeatureFlagListComponentData {
  featureFlagListResult: FeatureFlag[];
}
